import { useLocalStorage } from '@vueuse/core';

export interface AuthenticationState {
    signInAzureHasBeenCalled: any;
    signInAzureIsSuccessful: any;
    signInAzureError: any;
    codeVerifier: any;
    code: any;
    tokenAzure: any;
    accessToken: any;
    user: {
        email: any;
        ghUser: any;
        fullName: any;
        details: any;
        clients: any;
        idClient: any;
        role: any;
    };
    acquiringTokenSilent: boolean;
    portail: string;
}

export const state: AuthenticationState = {
    signInAzureHasBeenCalled: useLocalStorage('signInAzureHasBeenCalled', Boolean()),
    signInAzureIsSuccessful: useLocalStorage('signInAzureIsSuccessful', Boolean()),
    signInAzureError: useLocalStorage('signInAzureError', String()),
    codeVerifier: useLocalStorage('codeVerifier', String()),
    code: useLocalStorage('code', String()),
    tokenAzure: useLocalStorage('tokenAzure', String()),
    accessToken: useLocalStorage('accessToken', String()),
    user: {
        email: useLocalStorage('email', String()),
        ghUser: useLocalStorage('ghUser', Boolean()),
        fullName: useLocalStorage('fullName', String()),
        details: useLocalStorage('details', {}),
        clients: useLocalStorage('clients', {}),
        idClient: useLocalStorage('idClient', Number()),
        role: useLocalStorage('role', String()),
    },
    acquiringTokenSilent: false,
    portail: 'Client',
};
